import React, { useState } from "react";
import XMLFeedAnalysis from "./XMLFeedAnalysis";
import useAuth from "../hooks/useAuthProtected";

const ProtectedAnalyses: React.FC = () => {
  const [password, setPassword] = useState("");
  const { isAuthorized, loading, error, login } = useAuth();

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleLogin = () => {
    login(password);
    setPassword(""); // clear password input / state
  };

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div>
      {isAuthorized ? (
        <XMLFeedAnalysis />
      ) : (
        <div>
          <h2>Analýza XML feedů</h2>
          <p className="auth-hint">
            Pokud nevidíš vpravo počasí, analýza feedu nepůjde
          </p>
          <input
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Zadej heslo"
            onKeyDown={handleEnter}
            autoFocus
          />
          <button onClick={handleLogin} disabled={loading}>
            {loading ? "Ověřuji..." : "Přihlásit"}
          </button>
          {error && <p className="auth-error">{error}</p>}
        </div>
      )}
    </div>
  );
};

export default ProtectedAnalyses;
